<div class="container-fluid">
  <h2>
    {{ translate.currentLang == "ar" ? serviceNameAr :serviceNameEn }}
  </h2>
  <div class="title-tab-step text-center">
    {{ 'DISCOUNTSERVICESREQUEST' | translate }}
  </div>
  <div *ngIf="remainingPrice>0">
    <strong>المتبقي</strong> : {{remainingPrice}}
  </div>
  <div class="row p-3">
    <div class="col-sm-3">
      <div class="form-group">
        <div class="form-group">
          <label> {{ 'PERCENTORVALUE' | translate}}</label>
          <sanabel-selectize appcode="40" [(ngModel)]="serviceDiscount.percentOrValue" [simpleView]="true">
          </sanabel-selectize>
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group">
        <label>{{ 'DISCOUNTPERCENT' | translate }}</label>
        <input type="text" #inputValue class="form-control form-control-sm"
          (change)="onDiscountValueChange(inputValue.value)" [(ngModel)]="serviceDiscount.discountValue" autofocus />
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group">
        <label> {{ 'DISCOUNTREQUESTNOTES' | translate}}</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="serviceDiscount.discountRequestNotes" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <btns-ctrl #btnCtrl1 [appCodes]="[1]" (clicked)="save(serviceDiscount)"></btns-ctrl>
    </div>
  </div>
</div>